import { BoxLoading } from 'Components/Loaders';
import cls from 'classnames';
import { PageBoxesStateData } from 'core/redux/features/boxes/pageBoxes';
import { makeSelectResolveTokenFromString } from 'core/redux/features/shared/tokens';
import { AppState } from 'core/redux/reducers';
import React, { Component, createRef, CSSProperties, RefObject } from 'react';
import { connect } from 'react-redux';

interface IProps {
  item?: PageBoxesStateData;
  content?: string | null;
  className?: string;
  onMount?: (item: PageBoxesStateData, el: HTMLElement) => void;
}

type TState = {};

export function PageBoxItemLoader({ deviceType: _ }: { deviceType: string }) {
  return (
    <div className="section-loading" style={{ padding: '0 1rem' }}>
      <div className="section-content">
        <div className="container-small has-text-centered">
          <BoxLoading />
        </div>
      </div>
    </div>
  );
}

export function preppareProps(props: IProps) {
  const { item, className } = props;
  const styles: CSSProperties = {};
  const {
    background_type,
    html_class,
    background_image,
    id,
    font_color,
    enable_block_section,
    hide_app,
    fixed_width: fixedWidth,
  } = item;

  let bgUrl: string | null = null;
  const bgImage = background_image;

  if (bgImage && bgImage !== '' && bgImage[0] !== '#') {
    if (bgImage[0] !== '/' && bgImage.indexOf('://') < 0) {
      bgUrl = `/img/cache/section/${bgImage}`;
    }
  }

  if (background_type === 'color' && bgImage && bgImage[0] === '#') {
    styles.background = bgImage;
  } else {
    styles.background = '#fff';
  }

  if (font_color && (font_color[0] === '#' || font_color.indexOf('rgb') > -1)) {
    styles.color = font_color;
  }

  return {
    classes: cls(
      `bxx bxx--${id}`,
      enable_block_section === '1' && 'section section-box',
      html_class,
      bgUrl && 'has-cover has-colored',
      hide_app === '1' && 'boxlet--hideapp',
      className,
    ),
    styles,
    bgImage: bgUrl || '',
    fixedWidth,
  };
}

export class ItemComp extends Component<IProps, TState> {
  static defaultProps = {
    className: '',
  };
  private ref: RefObject<HTMLDivElement> = createRef();

  shouldComponentUpdate(
    _nextProps: Readonly<IProps>,
    _nextState: Readonly<TState>,
    _nextContext: any,
  ): boolean {
    return false;
  }

  componentDidMount(): void {
    const { item } = this.props;
    if (item && this.props.onMount && this.ref.current) {
      this.props.onMount(item, this.ref.current);
    }
  }

  render() {
    const { item, content } = this.props;

    if (!content) {
      return null;
    }

    // we can build classes and styles here because this component will not accept any updates
    const { classes, styles, bgImage, fixedWidth } = preppareProps(this.props);
    return (
      <div ref={this.ref} className={classes} style={styles}>
        {item?.background_color ? (
          <div
            className="boxlet-bg-color"
            style={{ background: item.background_color }}
          />
        ) : null}
        {bgImage !== '' ? (
          <div className="section-cover-wrap">
            <div className="section-cover">
              <img src={bgImage} alt={item?.background_alt} />
            </div>
          </div>
        ) : null}
        {fixedWidth === 1 ? (
          <div style={{ maxWidth: '620px', margin: '0 auto' }}>
            <div
              className="section-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        ) : (
          <div
            className="section-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: AppState, { item }: IProps) => ({
  content: item?.content
    ? makeSelectResolveTokenFromString()(state, item.content, 'box')
    : null,
});

const mapDispatchToProps = {};

const Item = connect(mapStateToProps, mapDispatchToProps)(ItemComp);
export default Item;
